import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat-input"
// Handles Enter to submit (Shift+Enter for new line) and auto-resize
export default class extends Controller {
  static targets = ["input", "submitButton"]

  connect() {
    this.resize()
    this.toggleSubmitButton()
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.inputTarget.value.trim() !== "") {
        this.element.requestSubmit()
      }
    }
  }

  resize() {
    const input = this.inputTarget
    input.style.height = "auto"
    input.style.height = input.scrollHeight + "px"
  }

  toggleSubmitButton() {
    if (!this.hasSubmitButtonTarget) return

    const isBlank = this.inputTarget.value.trim() === ""
    this.submitButtonTarget.disabled = isBlank || this.inputTarget.disabled
  }

  inputChanged() {
    this.resize()
    this.toggleSubmitButton()
  }
}
